<template>
  <el-form ref="form" :model="curInput.password" :rules="rules" label-width="100px">
    <el-form-item label="哈希算法" prop="encrypt_type">
      <el-select v-model="curInput.password.encrypt_type" placeholder="请选择哈希算法" class="h-40 w-200">
        <el-option v-for="item in hashType" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="加密拼接字符" prop="encrypt_split">
      <el-input v-model.trim="curInput.password.encrypt_split" class="h-40 w-200"></el-input>
    </el-form-item>
    <textlen-config :config="curInput.password" :limitMax="true" :limitMin="true"></textlen-config>
  </el-form>
</template>

<script>
  import textlenConfig from './textlenConfig'
  import _verify from '../../../assets/js/verify'
  export default {
    props: ['curInput'],
    data() {
      return {
        rules: {
          encrypt_split: []
        },
        hashType: [
          { id: 10, name: 'MD5' },
          { id: 20, name: 'SHA-256' }
        ]
      }
    },
    components: {
      textlenConfig
    },
    created() {
      this.rules.encrypt_split.push({ validator: this.vaildEncryptSplit, trigger: 'blur' })
    },
    methods: {
      vaildEncryptSplit(rules, value, callback) {
        if (value && !_verify.isEngAndNum(value)) {
          callback('加密拼接字符必须是数字和英文')
        } else {
          callback()
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// passwordConfig.vue?22b554fe